export const Registration: React.FC = () => {
    return(
        <div>Registration</div>
    );
}
